/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { useCallback } from "react";
import { CellLocation, Column } from "@silevis/reactgrid";
import { focusCellWithColumnIndex, errorCellsWithColumnIndices, focusCellWithColumnId } from "../utils";

export const useNavigateErrorCell = (
  focusState: { focusLocation: CellLocation; setFocusLocation: (loc: CellLocation) => void },
  columns: Column[],
  getErrorCells: () => { rowId: string; columnId: string }[]
) => {
  const moveToNextErrorCellOnEnter = useCallback((event: KeyboardEvent) => {
    setTimeout(() => {
      if (event.key === "Enter") {
        const currentCell = focusCellWithColumnIndex(focusState.focusLocation, columns);
        const errorCells = errorCellsWithColumnIndices(getErrorCells(), columns);

        const currentCellIndex = Number(currentCell.rowId) * columns.length + Number(currentCell.columnId);

        const nextErrorCell = errorCells.find(cell => {
          const errorCellIndex = Number(cell.rowId) * columns.length + Number(cell.columnId);
          return errorCellIndex > currentCellIndex;
        }) || errorCells[0];

        if (nextErrorCell) {
          const { rowId, columnId } = focusCellWithColumnId(nextErrorCell, columns);
          focusState.setFocusLocation({ rowId, columnId });
        }
      }
    }, 0);
  }, [focusState, columns, getErrorCells]);

  return { moveToNextErrorCellOnEnter };
};
